<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="标题">
              <a-input v-model="query.title" placeholder="请输入标题" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="状态">
              <a-select v-model="query.status" placeholder="请选择状态" allow-clear>
                <a-select-option :value="0">正常</a-select-option>
                <a-select-option :value="1">异常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="Oneclick()">一键同步</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">编辑</a>
        <!-- <a-divider type="vertical" /> -->
        <!-- <a @click="showLineLayer(record)">展示线</a> -->
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="statusAction" slot-scope="text">
        <a-tag v-if="text === 1" color="rgb(255, 99, 71)">异常</a-tag>
        <a-tag v-if="text === 0" color="rgb(50, 205, 50)">正常</a-tag>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">
          <a-input placeholder="标题" v-decorator="['title', { rules: [{ required: true, message: '请输入标题' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容">
          <a-input
            placeholder="内容"
            v-decorator="['contents', { rules: [{ required: true, message: '请输入内容' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <a-select v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }] }]">
            <a-select-option :value="1">异常</a-select-option>
            <a-select-option :value="0">正常</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发生时间">
          <a-date-picker
            v-decorator="['releaseTime', { rules: [{ required: true, message: '发生时间' }] }]"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="发生时间"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="同步" :width="800" v-model="Visible" @ok="OneOk" @cancel="Visible = false">
      <a-form-model class="log-form" :model="UpdateForm" ref="UpdateForm" :rules="rules">
        <a-form-model-item label="是否同步报警信息" prop="type" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
          <a-radio-group v-model="UpdateForm.type">
            <a-radio :value="0">同步</a-radio>
            <a-radio :value="1">不同步</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '标题',
    dataIndex: 'title',
  },
  {
    title: '内容',
    dataIndex: 'contents',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' },
  },
  {
    title: '发生时间',
    dataIndex: 'releaseTime',
    scopedSlots: { customRender: 'releaseTime' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'BulletinBoard',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/bulletin_board/page',
      deleteUrl: '/pipe-network/bulletin_board',
      addOrUpdateUrl: '/pipe-network/bulletin_board',
      queryOneUrl: '/pipe-network/bulletin_board',
      mapVisible: false,
      Visible: false,
      UpdateForm: {
        type: 0,
      },
      query: {
        title: '',
        status: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },

  created() {
    this.getAllTenant()
  },
  methods: {
    Oneclick() {
      this.Visible = true
    },
    OneOk() {
      this.$refs.UpdateForm.validate((valid) => {
        if (valid) {
          this.$http.post('/pipe-network/bulletin_board/sync', { ...this.UpdateForm }).then((res) => {
            if (res.code == 0) {
              this.$message.success(`操作成功`)
              this.queryList()
              this.Visible = false
            } else {
              this.$message.success(`操作失败！`)
              this.queryList()
              this.Visible = false
            }
          })
        }
      })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
